module.exports = __webpack_public_path__ + "static/media/marker.c7a1e2e3.svg";